import type { UsersFilters } from '@/api/users/usersQueries';
import { Input } from '@/components/common/Input';
import type { SelectOption } from '@/components/common/Select';
import { Select } from '@/components/common/Select';
import { Role } from '@/domain/Role';
import { useEffect, useRef, useState } from 'react';

const ALL_ROLES_VALUE = 'All roles';

const roleOptions: Array<SelectOption> = [
  { label: 'All roles', value: ALL_ROLES_VALUE },
  { label: 'Guest', value: Role.GUEST },
  { label: 'Customer', value: Role.CUSTOMER },
  { label: 'Doctor', value: Role.DOCTOR },
  { label: 'Packer', value: Role.PACKER },
];

interface UsersRowFiltersProps {
  filters: UsersFilters;
  onFiltersChange: (filters: UsersFilters) => void;
}

export function UsersRowFilters({
  filters,
  onFiltersChange,
}: UsersRowFiltersProps) {
  const [role, setRole] = useState(filters.role || ALL_ROLES_VALUE);
  const [nameSearch, setNameSearch] = useState(filters.search || '');
  const [emailSearch, setEmailSearch] = useState(filters.email || '');
  const filtersRef = useRef(filters);
  filtersRef.current = filters;

  useEffect(() => {
    const timer = setTimeout(() => {
      onFiltersChange({
        ...filtersRef.current,
        search: nameSearch || undefined,
        email: emailSearch || undefined,
      });
    }, 500);
    return () => clearTimeout(timer);
  }, [nameSearch, emailSearch]);

  const handleRoleChange = (value: string) => {
    setRole(value);
    const selectedRole =
      value === ALL_ROLES_VALUE ? undefined : (value as UsersFilters['role']);
    onFiltersChange({
      ...filtersRef.current,
      role: selectedRole,
    });
  };

  return (
    <div className="mb-4 flex flex-col gap-4 pt-2.5 md:flex-row">
      <div className="flex-1">
        <Select
          id="role-filter"
          name="role-filter"
          label="Select users type"
          options={roleOptions}
          value={role}
          onChange={handleRoleChange}
          placeholder="All roles"
          className="h-15.5"
        />
      </div>
      <div className="flex-1">
        <Input
          id="name-filter"
          name="search"
          label="Filter by Name"
          value={nameSearch}
          onChange={(e) => setNameSearch(e.target.value)}
        />
      </div>
      <div className="flex-1">
        <Input
          id="email-filter"
          name="email"
          label="Filter by Email"
          value={emailSearch}
          onChange={(e) => setEmailSearch(e.target.value)}
        />
      </div>
    </div>
  );
}
